/** @format */

import React from "react";

export default () => (
  <svg
    version="1.1"
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 144.1 180"
    style={{ enableBackground: "new 0 0 144.1 180" }}
  >
    <g>
      <path
        style={{ fill: "#D9BB7F" }}
        d="M106.5,92H105V68.5L81.3,42H40.9c-6.9,0-12.6,5.6-12.6,12.6v70.7c0,6.9,5.6,12.6,12.6,12.6h51.6
      c6.9,0,12.6-5.6,12.6-12.6v0h1.5c5.1,0,9.3-4.2,9.3-9.3v-14.7C115.8,96.2,111.6,92,106.5,92z M83,52.9l12.3,13.8H83V52.9z
       M99,125.4c0,3.6-3,6.6-6.6,6.6H40.9c-3.6,0-6.6-3-6.6-6.6V54.6c0-3.6,3-6.6,6.6-6.6H77v24.6h22V92H67.6c-5.1,0-9.3,4.2-9.3,9.3
      V116c0,5.1,4.2,9.3,9.3,9.3L99,125.4L99,125.4z M109.8,116c0,1.8-1.5,3.3-3.3,3.3H67.6c-1.8,0-3.3-1.5-3.3-3.3v-14.7
      c0-1.8,1.5-3.3,3.3-3.3h38.9c1.8,0,3.3,1.5,3.3,3.3V116z"
      />
      <path
        style={{ fill: "#D9BB7F" }}
        d="M74.7,102.5h-7V116h4.2V112h2.5c3.1,0,5.3-1.5,5.3-4.8C79.6,105.2,78.3,102.5,74.7,102.5z M73.5,108.7h-1.6
      V106h1.9c1,0,2,0.1,2,1.3C75.7,108.7,74.5,108.7,73.5,108.7z"
      />
      <path
        style={{ fill: "#D9BB7F" }}
        d="M87.8,102.5H81V116h6c4.7,0,6.9-2.6,6.9-6.8C93.9,105.9,92.3,102.5,87.8,102.5z M86.8,112.6h-1.6V106h1.3
      c3,0,3.3,2.4,3.3,3.2C89.8,110.5,89.4,112.6,86.8,112.6z"
      />
      <polygon
        style={{ fill: "#D9BB7F" }}
        points="95.7,116 99.9,116 99.9,110.9 105.3,110.9 105.3,107.7 99.9,107.7 99.9,106 106.2,106 106.2,102.5 
      95.7,102.5 	"
      />
    </g>
  </svg>
);
